import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const apiFetch = (path, opts = {}) =>
  fetch(`${API}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    ...opts,
  });

export function useAuth() {
  const [state, setState] = useState({ loading: true, user: null });

  useEffect(() => {
    let abort = false;
    apiFetch("/api/admin/me")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!abort) setState({ loading: false, user: data?.user || null });
      })
      .catch(() => {
        if (!abort) setState({ loading: false, user: null });
      });
    return () => {
      abort = true;
    };
  }, []);

  return state;
}
